/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BillingGroupTypeEnum = "Manual" | "SSO" | "%future added value";
export type EnforcementStateEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type InvitePolicyEnum = "AdminOnly" | "AnyMember" | "%future added value";
export type ProductTypeEnum = "Business_NonStandard" | "Business_Standard" | "Enterprise_NonStandard" | "Enterprise_Standard" | "Pro_NonStandard" | "Pro_Standard" | "%future added value";
export type SubscriptionTypeEnum = "Expired" | "FreemiumOrg" | "LegacyPrePaywall" | "PaidBillingGroup" | "PaidOrgPro" | "PaidTeamPro" | "PaidUserPro" | "SelfServePremiumOrgQ42020" | "SelfServePremiumTeamQ12021" | "%future added value";
export type AdminPanelBillingGroupsPlansAndBilling_org = {
    readonly id: string;
    readonly primaryOrgCalendar: string;
    readonly billingGroups: {
        readonly list?: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly createdAtMillis: unknown;
            readonly invitePolicy: InvitePolicyEnum;
            readonly type: BillingGroupTypeEnum | null;
            readonly personListPaginatedErrorable: ({
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
            } | {
                readonly __typename: "OrgPersonListPaginated";
                readonly count: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            }) | null;
            readonly manualMembers: {
                readonly __typename: "BillingGroupManualMemberList";
                readonly list: ReadonlyArray<{
                    readonly externalUserId: string;
                    readonly calendarId: string;
                    readonly userId: string | null;
                    readonly orgPerson: ({
                        readonly __typename: "OrgPerson";
                        readonly userId: string | null;
                        readonly personId: string;
                        readonly primaryCalendarId: string;
                        readonly isYou: boolean;
                        readonly signUpMillis: unknown | null;
                        readonly profile: {
                            readonly givenName: string | null;
                            readonly familyName: string | null;
                        } | null;
                    } | {
                        readonly __typename: "GraphEntityError";
                        readonly message: string | null;
                        readonly statusCode: number | null;
                    } | {
                        /*This will never be '%other', but we need some
                        value in case none of the concrete values match.*/
                        readonly __typename: "%other";
                    }) | null;
                }>;
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly adminOrgPersons: {
                readonly __typename: "OrgPersonList";
                readonly list: ReadonlyArray<{
                    readonly userId: string | null;
                    readonly personId: string;
                    readonly primaryCalendarId: string;
                    readonly isYou: boolean;
                    readonly signUpMillis: unknown | null;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                    } | null;
                }>;
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly subscription: {
                readonly __typename: "SubscriptionDetails";
                readonly subscription: {
                    readonly id: string;
                    readonly type: SubscriptionTypeEnum | null;
                    readonly productType: ProductTypeEnum | null;
                    readonly seatCount: number;
                };
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly stripeCustomerPortalSession: ({
                readonly __typename: "StripeCustomerPortalSession";
                readonly sessionUrl: string | null;
                readonly account: {
                    readonly accountId: string;
                    readonly stripeCustomerId: string;
                } | null;
            } | {
                readonly __typename: "GraphEntityError";
                readonly message: string | null;
                readonly statusCode: number | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            }) | null;
            readonly " $fragmentRefs": FragmentRefs<"SsoAdminPortalButton_billingGroup">;
        }> | undefined;
        readonly message?: string | null | undefined;
        readonly statusCode?: number | null | undefined;
    };
    readonly orgAccountingPeriod: {
        readonly __typename: "OrgAccountingPeriod";
        readonly periodRange: {
            readonly minDate: string;
            readonly maxDate: string;
        };
        readonly quotaMax: number;
        readonly quotaUsed: number;
        readonly enforcementState: EnforcementStateEnum;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly featureGrid: {
        readonly __typename: "FeatureGrid";
        readonly stateMetadata: {
            readonly primaryBillingGroupMetadata: {
                readonly subscription: {
                    readonly id: string;
                };
            } | null;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly currentOrgPersons: {
        readonly __typename: "OrgPersonList";
        readonly list: ReadonlyArray<{
            readonly primaryCalendarId: string;
            readonly userId: string | null;
            readonly personId: string;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
            readonly isYou: boolean;
            readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"AvatarRowNew_org" | "SsoAdminPortalButton_org">;
    readonly " $refType": "AdminPanelBillingGroupsPlansAndBilling_org";
};
export type AdminPanelBillingGroupsPlansAndBilling_org$data = AdminPanelBillingGroupsPlansAndBilling_org;
export type AdminPanelBillingGroupsPlansAndBilling_org$key = {
    readonly " $data"?: AdminPanelBillingGroupsPlansAndBilling_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AdminPanelBillingGroupsPlansAndBilling_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v10 = [
        (v4 /*: any*/),
        (v5 /*: any*/),
        (v6 /*: any*/),
        (v7 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signUpMillis",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
                (v8 /*: any*/),
                (v9 /*: any*/)
            ],
            "storageKey": null
        } as any
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v12 = {
        "kind": "InlineFragment",
        "selections": [
            (v3 /*: any*/),
            (v11 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v13 = {
        "kind": "InlineFragment",
        "selections": [
            (v11 /*: any*/),
            (v3 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "AdminPanelBillingGroupsPlansAndBilling_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgCalendar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillingGroup",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "createdAtMillis",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "invitePolicy",
                                        "storageKey": null
                                    },
                                    (v1 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "personListPaginatedErrorable",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    (v3 /*: any*/)
                                                ],
                                                "type": "GraphEntityError",
                                                "abstractKey": null
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "count",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "OrgPersonListPaginated",
                                                "abstractKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "manualMembers",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "BillingGroupManualMember",
                                                        "kind": "LinkedField",
                                                        "name": "list",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "externalUserId",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "calendarId",
                                                                "storageKey": null
                                                            },
                                                            (v4 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": null,
                                                                "kind": "LinkedField",
                                                                "name": "orgPerson",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v2 /*: any*/),
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": (v10 /*: any*/),
                                                                        "type": "OrgPerson",
                                                                        "abstractKey": null
                                                                    },
                                                                    (v12 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "BillingGroupManualMemberList",
                                                "abstractKey": null
                                            },
                                            (v12 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "adminOrgPersons",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "OrgPerson",
                                                        "kind": "LinkedField",
                                                        "name": "list",
                                                        "plural": true,
                                                        "selections": (v10 /*: any*/),
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "OrgPersonList",
                                                "abstractKey": null
                                            },
                                            (v12 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "subscription",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "PaymentSubscription",
                                                        "kind": "LinkedField",
                                                        "name": "subscription",
                                                        "plural": false,
                                                        "selections": [
                                                            (v0 /*: any*/),
                                                            (v1 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "productType",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "seatCount",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "SubscriptionDetails",
                                                "abstractKey": null
                                            },
                                            (v12 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "stripeCustomerPortalSession",
                                        "plural": false,
                                        "selections": [
                                            (v2 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "sessionUrl",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "AccountStripe",
                                                        "kind": "LinkedField",
                                                        "name": "account",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "accountId",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "stripeCustomerId",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "StripeCustomerPortalSession",
                                                "abstractKey": null
                                            },
                                            (v12 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SsoAdminPortalButton_billingGroup"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "BillingGroupList",
                        "abstractKey": null
                    },
                    (v12 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgAccountingPeriod",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DateRange",
                                "kind": "LinkedField",
                                "name": "periodRange",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "minDate",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxDate",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaMax",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "quotaUsed",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enforcementState",
                                "storageKey": null
                            }
                        ],
                        "type": "OrgAccountingPeriod",
                        "abstractKey": null
                    },
                    (v12 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "featureGrid",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentStateMetadata",
                                "kind": "LinkedField",
                                "name": "stateMetadata",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PrimaryBillingGroupMetadata",
                                        "kind": "LinkedField",
                                        "name": "primaryBillingGroupMetadata",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "PaymentSubscription",
                                                "kind": "LinkedField",
                                                "name": "subscription",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "FeatureGrid",
                        "abstractKey": null
                    },
                    (v13 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentOrgPersons",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgPerson",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v6 /*: any*/),
                                    (v4 /*: any*/),
                                    (v5 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserProfile",
                                        "kind": "LinkedField",
                                        "name": "profile",
                                        "plural": false,
                                        "selections": [
                                            (v8 /*: any*/),
                                            (v9 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "externalImageUrl",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    (v7 /*: any*/),
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "AvatarPerson_orgPerson"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "OrgPersonList",
                        "abstractKey": null
                    },
                    (v13 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AvatarRowNew_org"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SsoAdminPortalButton_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '2da85ea1cc6ec52e90b5e5a49919b579';
export default node;
